import SearchDataSources from './SearchDataSources'

export default SearchDataSources
